var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.727 24.254c3.374 10.251-.606 22.968-9.69 29.889-9.126 6.92-23.357 8.045-32.44 1.557-9.04-6.445-12.933-20.546-9.17-31.36C11.19 13.485 22.609 5.915 33.639 6c11.073.13 21.757 7.96 25.088 18.254z",
    fill: "url(#ai-video-icon_svg__paint0_linear_419_5939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.486 33.954c-.246 1.018-1.41 1.738-3.736 3.178-2.25 1.39-3.374 2.087-4.28 1.807a2.235 2.235 0 01-.991-.638c-.666-.731-.666-2.15-.666-4.989 0-2.838 0-4.257.666-4.988.275-.303.616-.522.99-.638.907-.28 2.032.416 4.281 1.807 2.327 1.44 3.49 2.16 3.736 3.178.102.42.102.863 0 1.283z",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.121 30.875c.004.764.004 1.575.004 2.438 0 7.277 0 10.915-2.26 13.176-2.262 2.261-5.9 2.261-13.178 2.261-7.277 0-10.915 0-13.176-2.26-2.261-2.262-2.261-5.9-2.261-13.178 0-7.277 0-10.915 2.26-13.176 2.261-2.261 5.9-2.261 13.177-2.261.863 0 1.674 0 2.438.004",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.063 16.25l.419 1.133c.55 1.485.824 2.227 1.366 2.77.541.541 1.284.816 2.77 1.365l1.132.42-1.133.419c-1.485.55-2.227.824-2.77 1.366-.541.542-.816 1.284-1.365 2.77l-.42 1.132-.419-1.133c-.55-1.485-.824-2.227-1.366-2.77-.541-.541-1.284-.816-2.77-1.365l-1.132-.42 1.133-.419c1.485-.55 2.227-.824 2.77-1.366.541-.542.816-1.284 1.365-2.77l.42-1.132z",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-video-icon_svg__paint0_linear_419_5939",
    x1: 32.958,
    y1: 6,
    x2: 32.958,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
export default SvgAiVideoIcon;